import postWithToken from './base/post-with-token'

const updateTaxonomyBenchmark = (id, data) => postWithToken(`/customer-taxonomy/${id}/benchmark`)(data)

export default updateTaxonomyBenchmark
